import routing from "./routing";
import provider from "./routingContext";

const Routing = Object.assign(routing, {
  Provider: provider,
});

export default Routing;
